<template>
  <div class="desktop-beta-container">
    <div class="center">
      <router-link :to="{ name: 'top' }">
        <img class="logo" src="~@/assets/img/logo.png" />
      </router-link>
      <div class="cat-icon-slot">
        <cat-icon writerType="elas" :clickable="false" />
      </div>
    </div>
    <div class="desktop-beta-container__card">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";

export default Vue.extend({
  name: "DesktopBetaContainer",
  components: {
    CatIcon,
  },
});
</script>

<style lang="scss" scoped>
$logo-width: 100px;

.logo {
  width: $logo-width;
}

.desktop-beta-container {
  padding: 16px;
  width: 560px;
  min-width: 300px;
  color: var(--color-text-normal);

  @include mq(sp) {
    padding: 20px 16px;
    width: 95%;
    min-width: 0;
  }

  .center {
    text-align: center;
    position: relative;
    margin-bottom: 12px;
  }

  .cat-icon-slot {
    position: absolute;
    top: -16px;
    left: auto;
    right: 120px;
    width: 80px;
    height: 80px;
  }

  @include mq(sp) {
    .cat-icon-slot {
      left: 50%;
      right: auto;
      transform: translateX(calc(#{$logo-width} / 2));
    }
  }

  &__card {
    background-color: var(--color-background-normal);
    border-radius: var(--radius-lg);
    padding: 28px 24px;
    box-shadow: var(--shadow-lg);
    position: relative;
    z-index: 1;
  }
}
</style>
